// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__+KJLy","activeMenuItem":"Header_activeMenuItem__8Zn+A","linkItem":"Header_linkItem__vJEld"};